import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { toast } from 'react-toastify';
import './Home.css';
import axios from '../../utils/axiosConfig';
import homeService from '../../features/home/homeService';
import config from '../../utils/Config';
import Spinner from '../Layout/Spinner';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom'
import authService from '../../features/auth/authService';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


function Home(props) {

  let [surveySelection, setSurveySelection] = useState([])
  let [surveyList, setSurveyList] = useState([])
  let [orderDashboardSelection, setOrderDashboardSelection] = useState([
    { image: 'dbSubscription.png', title: 'ORDER DASHBOARD', value: false },
  ])
  let [checkup, setCheckup] = useState(false)
  let [checkdown, setCheckdown] = useState(false)
  let [counties, setCounties] = useState([]);
  let [homepageData, setHomePageData] = useState({});
  let [isLoading, setIsLoading] = useState(false);
  let [selectedDistrict, setselectedDistrict] = useState({});
  const [orderDashboard, setOrderDashboard] = useState(false);
  const [distdropdownData, setDistrictDropwdownData] = useState(false);
  const [selectedCounty, setSelectedCounty] = useState('');
  const [districtlist, setDistricts] = useState([]);
  const [isPreSubscription, setPreSubscription] = useState(false);

  const navigate = useNavigate()


  useEffect(() => {
    document.title = props.title
    fetchData()
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      homeService.getHomePageDate({ districtId: authService.getDist(), userId: authService.getUserId(),academicyear:localStorage.getItem("academicyear") }).then((response) => {
        
        const jsonData = response.data;
        const convertedData = homeService.convertSurveyList(jsonData.homePageData.surveyList)

        if((jsonData.homePageData.surveyList).length == 0) {
          toast.error('School is not assigned to the selected District')
        }
      
        if (convertedData.some(item => item.value === 1 || item.value === true)) {
          setCheckup(true);
        } else {
          setCheckup(false);
        }
        const isSurveySelected = convertedData.some(item => item.value === 1 || item.value === true);
        const uniqueCounty = homeService.getUniqueCounty(jsonData.homePageData.districtDropdownData);
        const county_selected_districts = homeService.getdistrictsofselectedcounty(jsonData.homePageData.districtDropdownData, jsonData.homePageData.defaultCounty);
        setPreSubscription(jsonData.homePageData.isPreSubscription);
        if (jsonData.homePageData.isPreSubscription) setCheckup(true);

        if (jsonData.homePageData.distSubmitType == 'sr' && localStorage.getItem('role') == 'dc') {
          toast.info('Survey Registration has been submitted. To update your survey selections, please contact your CalSCHLS Technical Advisor.')
        }

        handleHomePageStates(jsonData.homePageData.distSubmitType, jsonData.homePageData.isPreSubscription);
        setDistrictDropwdownData(jsonData.homePageData.districtDropdownData)
        setSurveyList(convertedData);
        setSurveySelection(convertedData);
        setCounties(uniqueCounty);
        setDistricts(county_selected_districts);
        setHomePageData(jsonData.homePageData);
        setSelectedCounty(jsonData.homePageData.defaultCounty)
        setselectedDistrict(localStorage.getItem('districtId'))

        if (convertedData.some(item => item.value === 1 || item.value === true)) {
          setCheckup(true);
        }
        setIsLoading(false);
        setIsLoading(false);
      }).catch(err => {
        toast.error(err.message ? err.message : "Unable to fetch home data.");
        setIsLoading(false);
      })
    } catch (error) {
      console.error('Error fetching home data:', error);
    }
  };

  const handleHomePageStates = (disttype, isPreSubscription) => {
    if (disttype == 'new') {
      setCheckup(false);
      setCheckdown(false);
    } else if (disttype == 'do') {
      orderDashboardSelection[0]['value'] = true;
      setCheckup(true);
      setCheckdown(true);
    }
    else if (disttype == 'sr') {
      setCheckup(true);
      setCheckdown(true);
    }
    else if (disttype == 'srwd') {
      setCheckup(false);
      setCheckdown(false);

    } else if (disttype == 'dowd') {
      orderDashboardSelection[0]['value'] = true;
      setCheckup(false);
      setCheckdown(true);
    }
    else if (disttype == 'sr') {
      console.log(disttype);
      setCheckup(true);
      setCheckdown(true);
    }
    else if (disttype == 'srwd') {
      setCheckup(true);
      setCheckdown(false);
    } else if (disttype == 'dowd') {
      orderDashboardSelection[0]['value'] = true;
      setCheckup(false);
      setCheckdown(true);

    }
    localStorage.getItem("academicyear") !== "currentyear" && setCheckdown(true);

  }

  const handleOrderDashboard = () => {
    if (orderDashboardSelection[0]['value']) {
      setOrderDashboard(true);
    } else {
      toast.warning('Click “Order Dashboard Only” to continue.');
    }
  }

  const handleClose = () => {
    setOrderDashboard(false);
  };


  const handleNext = async () => {
    try {
      if (surveyList.some(item => item.value === 1 || item.value === true) ||
        surveySelection.some(item => item.value === 1 || item.value === true)
      ) {
        setIsLoading(true);
        homeService.submitHomePageDate({ districtId: authService.getDist(), surveys: surveyList }).then((response) => {
          if (response.data.success) {
            navigate('/survey');
          }
          // toast.success(response.data.message);
          setIsLoading(false);
        }).catch(err => {
          toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
          setIsLoading(false);
        })
      } else {
        toast.warning('Select at least one survey to continue with the registration.');
      }
    } catch (error) {
      toast.error(error.message ? error.message : "Error in submiting dashboard only registration")
      console.error('Error saving data:', error);
      setIsLoading(false);

    }
  };

  const onDistrictSelect = async (event) => {
    localStorage.setItem('districtId', event);
    fetchData();
  };

  const onCountySelect = (e) => {
    setSelectedCounty(e.target.value);
    const county_selected_districts = homeService.getdistrictsofselectedcounty(distdropdownData, e.target.value);
    setDistricts(county_selected_districts);
    setselectedDistrict(county_selected_districts[0].district_id);
    setLocalStrorageItems(e.target.value, county_selected_districts[0].district_id)
    fetchData()
  };

  const setLocalStrorageItems = (countyId, districtId) => {
    localStorage.setItem('countyId', countyId);
    localStorage.setItem('districtId', districtId);
  }

  let finalCheckValueUp = false
  let lengthForFalseUp = 0

  let finalCheckValueDown = false
  let lengthForFalseDown = 0

  let changeState = (event, index, val) => {
    // console.log(index);
    if (val == 'survey' && homepageData.distSubmitType != 'sr') {
      setSurveySelection(
        surveySelection.map((item, ind1) => {

          if (ind1 == index) item.value = !item.value

          if (item.value) {
            finalCheckValueUp = true
          } else {
            lengthForFalseUp = lengthForFalseUp + 1
          }
          return item
        }))
      if (lengthForFalseUp == surveySelection.length) {
        finalCheckValueUp = false
      }
      setCheckup(finalCheckValueUp)
      lengthForFalseUp = 0
    } else if (val == 'dashboard' && homepageData.distSubmitType != 'do') {
      setOrderDashboardSelection(
        orderDashboardSelection.map((items, ind2) => {
          if (ind2 == index) items.value = !items.value
          if (items.value) {
            finalCheckValueDown = true
          } else {
            lengthForFalseDown = lengthForFalseDown + 1
          }
          return items
        }))
      if (lengthForFalseDown == orderDashboardSelection.length) {
        finalCheckValueDown = false
      }
      setCheckdown(finalCheckValueDown)
      lengthForFalseDown = 0
    }

  }
  const handleOrderDashboardNext = async () => {
    // submitdashboardonly
    setIsLoading(true);
    homeService.saveOrderDashboardData({ districtId: authService.getDist() }).then((response) => {
      if (response.data.success) {
        toast.success('Order Data Dashboard Submitted Successfully');
      } else {
        toast.error(response.data.message);
      }
      setOrderDashboard(false);
      setIsLoading(false);
      navigate('/report');

    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
      setIsLoading(false);
      setOrderDashboard(false);
    })
  }

  return (
    <>
      {(isLoading === true) ? <Spinner></Spinner> : ""}
      { surveySelection.length > 0 ? (
        <>
      <div className='home_pageHeader'>
        {/* <div className="text-inside-grid">Survey Selection</div> */}
        <div className="pageText">Survey Selection</div>
      </div>
    
      <div className='homeContent'>
        <Grid container rowSpacing={4} columnSpacing={2}>

          <div className="home-form-container">
            <FormControl className="text-inside-grid" variant="standard" sx={{ minWidth: 420 }}>
              <InputLabel id="demo-simple-select-standard-label">Select County</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedCounty}
                onChange={onCountySelect}
                label="Country">
                {counties.map((country) => (
                  <MenuItem key={country.county_id} value={country.county_id}>
                    {country.county_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className="text-inside-grid" variant="standard" sx={{ m: 0, minWidth: 420 }}>
              <InputLabel id="demo-simple-select-standard-label">Select District</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedDistrict}
                onChange={(e) => onDistrictSelect(e.target.value)}
                label="District">
                {districtlist.map((dist) => (
                  <MenuItem key={dist.district_id} value={dist.district_id}>
                    {dist.district_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <Grid className="surveyGrid" container spacing={2} >

            {/* {surveySelection.map((data, index) =>

              <Grid className={checkdown ? 'disablegrid left' : 'boxOuter left'} item xs={1.8}>
                <Item className='boxStyle'>
                  <div className='surveyCheck'>
                    {data.value ?
                      <img className='imageCheck' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img> : ''}
                  </div>
                  <a onClick={event => changeState(event, index, 'survey')} style={{ cursor: 'pointer' }}>

                    <div className='imageClass'>
                      <img className='cardImage' src={require(`../../assets/images/${data.image}`)} alt='Elementary Survey'></img>
                    </div>
                    <div className='imageContent'>
                      <div>{data.title.replace("SURVEY", "")}</div>
                      <div>SURVEY</div>
                    </div>
                  </a>
                </Item>
              </Grid>
            )} */}

            <div className="flex-container">
              {surveySelection.map((data, index) => (
                <div className={checkdown ? 'disablegrid left' : 'boxOuter left'} key={index}>
                  <div className='boxStyle'>
                    <div className='surveyCheck'>
                      {data.value ? (
                        <img className='imageCheck' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check' />
                      ) : (
                        ''
                      )}
                    </div>

                    <a onClick={localStorage.getItem("academicyear") === 'currentyear' ? (event) => changeState(event, index, 'survey') : null} style={{ cursor: 'pointer' }}>
                      <div className='imageClass'>
                        <img className='cardImage' src={require(`../../assets/images/${data.image}`)} alt='Elementary Survey' />
                      </div>
                      <div className='imageContent'>
                        <div>{data.title.replace('SURVEY', '')}</div>
                        <div>SURVEY</div>
                      </div>
                    </a>
                  </div>
                </div>
              ))}

            {!checkdown && localStorage.getItem("academicyear") === 'currentyear' && (
              <div className='boxOuter'>
                <Item className='boxStyle' onClick={handleNext} style={{ cursor: 'pointer' }}>
                  <div style={{ paddingTop: 22 }}>
                    <img className='cardImage' src={require('../../assets/images/arrow_right.png')} alt='Next button Image'></img>
                    <div className='nextClass'>NEXT</div>
                  </div>
                </Item>
              </div>
            )}

            </div>

            <Grid xs={12} style={{ padding: 0, marginBottom: '8px' }} container item>
              <div className="pageTextHome" style={{ paddingBottom: "0" }}>Order Dashboard Only</div>
            </Grid>


            <Grid className='left' style={{ padding: '0px 0px 20px 0px' }} xs={12} container item>
              <div className="smallText">
                If you will not administer any surveys this year and only wish to order the data Dashboard,
                please check the box below.
              </div>
            </Grid>

            <Dialog className='left' open={orderDashboard} onClose={handleClose} aria-labelledby="dialog-title" disableEscapeKeyDown>
              <center><DialogTitle id="dialog-title" style={{ height: '0px', margin: '0px' }}>Order Dashboard Only</DialogTitle></center>
              <DialogContent className='deleteParaHome'>
                <p>
                  Are you sure that you only wish to order the Data Dashboard and will not administer any surveys this year?
                </p>
              </DialogContent>
              <DialogActions style={{ justifyContent: 'center', marginBottom: '15px' }}>
                <Button style={{ cursor: 'pointer', backgroundColor: '#ff0000', color: 'white', height: '32px', width: '64px', padding: '4px' }} onClick={handleClose}>
                  NO
                </Button>
                <Button style={{ cursor: 'pointer', backgroundColor: '#1f9d24', color: 'white', height: '32px', width: '64px', padding: '4px' }} onClick={handleOrderDashboardNext}>
                  YES
                </Button>
              </DialogActions>
            </Dialog>


            {orderDashboardSelection.map((data, index) =>

              <Grid className={isPreSubscription ? 'disablegrid left' : (checkup ? 'disablegrid left' : 'boxOuter left')} item xs={1.8}>
                <Item className='boxStyle'>
                  <div className='surveyCheck'>
                    {data.value ? <img className='imageCheck' src={require('../../assets/images/surveyCheck.png')} alt='Survey Check'></img> : ''}
                  </div>
                  <a onClick={localStorage.getItem("academicyear") === 'currentyear' ? (event) => changeState(event, index, 'dashboard') : null} style={{ cursor: 'pointer' }}>
                    <div className='imageClass'>
                      <img className='cardImage' src={require(`../../assets/images/${data.image}`)} alt='Order Dashboard Only'></img>
                    </div>
                    <div className='imageContent'>
                      <div>{data.title}</div>
                      <div>ONLY</div>
                    </div>
                  </a>
                </Item>
              </Grid>
            )}

            {!checkup && !isPreSubscription && localStorage.getItem("academicyear") === 'currentyear' ? <Grid className='boxOuter' item xs={2}>
              <Item className='boxStyle' onClick={handleOrderDashboard} style={{ cursor: 'pointer' }}>
                <div style={{ paddingTop: 22 }} >
                  <img className='cardImage' src={require('../../assets/images/arrow_right.png')} alt='Next button Image'></img>
                  <div className='nextClass'>NEXT</div>
                </div>
              </Item>

            </Grid> : ''}


            {/* {!checkup ? */}
            <Grid className='dashboardText left' item xs={12} >
              <div
                className="smallText"
                style = {{ 'padding': '20px 0px 0px 0px' }}
                ref={el => {
                  if (el) {
                    el.style.setProperty('marginTop', '0px', 'important');
                  }
                }} >
                The Order Dashboard Only box cannot be selected if your district is administering a survey or your data Dashboard subscription is still active.</div>
            </Grid>
            {/* : ''} */}
          </Grid>
        </Grid>
      </div > 
      </>)
       : ''}
    </>

  )

}

export default Home